import { ThemeProvider } from "@mui/styles";
import { Document, Image, Page, PDFViewer, Text, View } from '@react-pdf/renderer';
import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { GetOrderById } from "../services/Transaction";
import "../styles/style.css";
import theme from "../styles/theme";

const ShippingDoc = () => {
	let logo = '/assets/images/logo-pernik-hsi.png'
	let webIcon = '/assets/images/web.png'
	let facebookIcon = '/assets/images/facebook.png'
	let instagramIcon = '/assets/images/instagram.png'
	let whatsappIcon = '/assets/images/whatsapp.png'
	const [invoice, setInvoice] = useState({});
	const { id } = useParams();
	const BackIcon = "/assets/svg/back.svg";

	const getInvoice = () => {
		GetOrderById(id)
			.then(res => {
				setInvoice(res.data)
			})
			.catch(err => {
				alert(err)
			})
	}

	useEffect(() => {
		getInvoice();
	}, [getInvoice]);

	let contactPerson = invoice?.delivery_service?.destination_address?.contact_person || invoice?.customer?.name
	let addressLine1 = invoice?.delivery_service?.destination_address?.complete
	let addressLine2 = invoice?.delivery_service?.destination_address?.urban_village?.name ?? ''
	if (invoice?.delivery_service?.destination_address?.subdistrict?.name) {
		addressLine2 += ', ' + invoice?.delivery_service?.destination_address?.subdistrict?.name
	}
	if (invoice?.delivery_service?.destination_address?.city?.name) {
		addressLine2 += ', ' + invoice?.delivery_service?.destination_address?.city?.name
	}
	if (invoice?.delivery_service?.destination_address?.province?.name) {
		addressLine2 += ', ' + invoice?.delivery_service?.destination_address?.province?.name
	}
	if (invoice?.delivery_service?.destination_address?.postal_code) {
		addressLine2 += ' ' + invoice?.delivery_service?.destination_address?.postal_code
	}
	return (
		<ThemeProvider theme={theme}>
			<div className="header">
				<Link to={'/transaksi/' + id} style={{ position: "absolute", height: 60, width: 60, top: 0, left: 0 }}>
					<img alt="icon" src={BackIcon} />
				</Link>
				<div className="center">
					<h3 className="title">Lembar Pengiriman</h3>
				</div>
			</div>
			<PDFViewer style={{ marginTop: 60, width: '100%', height: 680 }} >
				<Document>
					<Page size="A5" orientation="landscape" style={{ fontFamily: 'Helvetica', fontWeight: 'bold', fontSize: 11, paddingTop: 10, paddingLeft: 10, paddingRight: 10, lineHeight: 1.5, flexDirection: 'column' }}>
						<View style={{ borderWidth: 2, alignItems: 'center', padding: 2 }}>
							<View style={{ flexDirection: 'row', flexGrow: 1, borderTopWidth: 2, borderLeftWidth: 2, borderRightWidth: 2, borderBottomWidth: 1 }}>
								<View style={{ width: '40%', padding: 2 }}>
									<Text style={{ fontFamily: 'Helvetica-Bold', paddingTop: 5 }}>PENGIRIM</Text>
								</View>
								<View style={{ width: '60%', borderLeftWidth: 1, padding: 2 }}>
									<Text style={{ fontFamily: 'Helvetica-Bold', paddingTop: 5 }}>PENERIMA</Text>
								</View>
							</View>
							<View style={{ flexDirection: 'row', flexGrow: 1, borderLeftWidth: 2, borderRightWidth: 2, borderBottomWidth: 1 }}>
								<View style={{ width: '40%' }}>
									<View style={{ paddingTop: 5 }} />
									<Text style={{ paddingLeft: 5, fontFamily: 'Helvetica-Bold' }}>PERNIK HSI</Text>
									<Text style={{ paddingLeft: 15 }}>Back Office HSI AbdullahRoy</Text>
									<Text style={{ paddingLeft: 15 }}>Dagen RT05, Gumuk, Ringinharjo, Bantul</Text>
									<Text style={{ paddingLeft: 15 }}>Bantul, Daerah Istimewa Yogyakarta 55712</Text>
									<View style={{ paddingTop: 5 }} />
									<Text style={{ paddingLeft: 15, fontFamily: 'Helvetica-Bold' }}>0812 3100 0045</Text>
									<Image src={logo} style={{ margin: 'auto', justifyContent: 'center', height: 60, padding: 10 }} />
								</View>
								<View style={{ width: '60%', borderLeftWidth: 1 }}>
									<View style={{ paddingTop: 5 }} />
									<Text style={{ paddingLeft: 5, fontFamily: 'Helvetica-Bold' }}>Alamat Pengiriman:</Text>
									<Text style={{ paddingLeft: 15, fontFamily: 'Helvetica-Bold' }}>{contactPerson}</Text>
									<Text style={{ paddingLeft: 15 }}>{addressLine1}</Text>
									<Text style={{ paddingLeft: 15 }}>{addressLine2}</Text>
									<Text style={{ paddingLeft: 15 }}>Nomor HP : {invoice?.delivery_service?.destination_address?.phone}</Text>
									<View style={{ borderTopWidth: 1, marginTop: 5, marginBottom: 5 }} />
									<Text style={{ paddingLeft: 5, fontFamily: 'Helvetica-Bold' }}>Jasa Pengiriman:</Text>
									<Text style={{ paddingLeft: 15 }}>{invoice?.delivery_service?.courier_service?.name || '-'}</Text>
								</View>
							</View>
							<View style={{ borderLeftWidth: 2, borderRightWidth: 2, borderBottomWidth: 1, width: '100%' }}>
								<View style={{ flexDirection: 'row', flexGrow: 1, margin: 'auto', justifyContent: 'center' }}>
									<View style={{ padding: 5 }}>
										<Text style={{ fontFamily: 'Helvetica-Bold' }}>Rincian:</Text>
										<View style={{ padding: 5 }}>
											{invoice?.line_items?.map(item => 
												<View key={item.id} style={{ flexDirection: 'row', flexGrow: 1, padding: 2 }}>
													<Image src={{ uri: item.product?.image?.url, method: "GET", headers: { "Cache-Control": "no-cache" }, body: "" }} style={{ height: 36, width: 36 }} />
													<View >
														<Text style={{ fontFamily: 'Helvetica-Bold' }}>{item.description}</Text>
														<Text style={{ color: '#333333' }}>{item.quantity.toLocaleString().replaceAll(',', '.')} Pcs x Rp {item.unit_price.toLocaleString().replaceAll(',', '.')} = Rp {(item.quantity * item.unit_price).toLocaleString().replaceAll(',', '.')}</Text>
													</View>
												</View>
											)}
										</View>
									</View>
								</View>
							</View>
							<View style={{ borderLeftWidth: 2, borderRightWidth: 2, borderBottomWidth: 2, width: '100%', paddingTop: 5, paddingBottom: 5 }}>
								<View style={{ flexDirection: 'row', flexGrow: 1, width: '80%', color: '#FFFFFF', backgroundColor: '#333333', margin: 'auto', justifyContent: 'center' }}>
									<Image src={webIcon} style={{ height: 16, width: 16, padding: 2, marginTop: 4 }} />
									<Text style={{ paddingTop: 5, paddingBottom: 5, paddingLeft: 3, paddingRight: 10 }} >pernik.hsi.id</Text>
									<Image src={instagramIcon} style={{ height: 16, width: 16, padding: 2, marginTop: 4 }} />
									<Image src={facebookIcon} style={{ height: 16, width: 16, padding: 2, marginTop: 4 }} />
									<Text style={{ paddingTop: 5, paddingBottom: 5, paddingLeft: 3, paddingRight: 10 }} >pernikhsi.official</Text>
									<Image src={whatsappIcon} style={{ height: 16, width: 16, padding: 2, marginTop: 4 }} />
									<Text style={{ paddingTop: 5, paddingBottom: 5, paddingLeft: 3 }} >081231000046</Text>
								</View>
							</View>
						</View>
					</Page>
				</Document>
			</PDFViewer>
		</ThemeProvider>
	)
}

export default ShippingDoc
